<template>
  <div class="big-home">
      <div class="banner"><img src="./banner-bighome.jpg" alt="" width="100%"></div>
      <div class="home-main">
        <p class="tit clearfix">
            <span><a href="/">首页</a></span>
            <span class="arr-bold">&gt;</span>
            <span>亚商大家庭</span>
            <span class="arr-bold">&gt;</span>
            <span class="font-blue" v-if="currentIndex === 0">亚商资本</span>
            <span class="font-blue" v-if="currentIndex === 1">亚商投顾</span>
        </p>
        <div class="content">
          <ul class="tab">
            <li v-for="(item, index) in tabList" :key="index" :class="{'active': currentIndex === index}" @click="tabEvent(item.id)">{{item.menu}}</li>
          </ul>
          <div class="tab-content">
            <div v-if="currentIndex === 0">
              <div class="clearfix">
                <p class="text text-float1 fl"><span class="circle"></span> <a href="http://www.abccapital.cn/" target="_blank" style="color:#666;">亚商资本</a>是亚商集团的股权投资平台，也是中国最早从事风险投资和股权投资的专业投资机构。亚商资本专注高成长行业的创业者和具备快增长潜力的成长型企业，自2000年至今前后共设立并管理十多只基金，七十多亿人民币。</p>
                <p class="text text-float2 fr"><span class="circle"></span> <a href="http://www.abccapital.cn/" target="_blank" style="color:#666;">亚商资本</a>专注对创业早期和成长型企业的投资和增值服务。在国内主要经济中心城市设有分支机构和子基金，并和各地政府引导基金合作，深耕当地企业。</p>
              </div>
              <p class="title">获奖情况</p>
              <div class="img">
                <img src="./hj.png" alt="">
              </div>
              <p class="title">旗下基金</p>
              <!-- <p class="text">亚商资本是中国领先的移动互联网，新消费，大健康和文体娱乐领域领域私募股权投资基金</p> -->
              <p class="text"><span class="circle"></span>亚商创投系列基金——成长型企业投资的基金群,专注对成长型企业的投资和增值服务。</p>
              <p class="text"><span class="circle"></span>亚商加速器系列基金——早期创业投资基金群，专注对创业早中期企业的投资和增值服务。在国内主要经济中心城市设有分支机构和子基金，和各地政府引导基金合作，深耕当地企业。</p>
              <p class="text"><span class="circle"></span>亚商新材料基金——重点关注包括新材料及其相关产品和技术装备的早中期企业。</p>
              <p class="text"><span class="circle"></span>亚商TMT行业基金——以数字新媒体行业项目为主的早中期基金。</p>
              <p class="text"><span class="circle"></span>亚商大健康行业基金——以健康消费为核心，关注医疗器械、保健服务等大健康领域。</p>

              <!-- <p class="title">上市项目(部分)</p>
              <div class="img mediaImg">
                <img src="./shangshi.png" alt="">
              </div>
              <p class="title">已挂牌项目</p>
              <div class="img mediaImg">
                <img src="./guapai.png" alt="">
              </div> -->
              <p class="enter-ziben">
                <a href="http://www.abccapital.cn" target="_blank">【进入“亚商资本”官网】</a>
              </p>
            </div>
            <div v-if="currentIndex === 1">
              <div class="clearfix">
                <p class="text text-float1 fl"><span class="circle"></span>	亚商投顾是亚商集团的资产管理平台，前身为亚商咨询和亚商投行，是中国本土成立最早（1988年）、最具专业实力的顾问咨询与并购重组专业机构之一，证监会首批颁发的投资顾问与并购重组持牌机构。亚商投顾操作过多起上市公司大型并购交易，涉及金额超过1,000亿人民币。</p>
                <p class="text text-float2 fr mb-20"><span class="circle"></span>  亚商投顾近三十年来为国内数百家大型企业集团、上市公司和优秀民营企业提供专业顾问服务，并为包括国家国资委和上海国资委在内的众多地方政府提供长期的顾问咨询服务。</p>
              </div>
              <div>
                <img src="./tougu.png" alt="">
              </div>
              <p class="title">案例展示</p>
              <div class="img mediaImg">
                <img src="./anli.png" alt="">
              </div>
              <p class="enter-ziben">
                <a href="https://www.abctougu.cn" target="_blank">【进入“亚商投顾”官网】</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <go-top></go-top>
  </div>
</template>

<script>
import goTop from "../../common/go-top.vue";
let storeIndex = 0;
export default {
  name: 'BigHome',
  components: {
    goTop
  },
  data () {
    return {
      tabList: [
        {
          id: 0,
          menu: '亚 商 资 本'
         },
         {
           id: 1,
           menu: '亚 商 投 顾'
         }
      ],
      currentIndex: 0
    }
  },
  methods: {
    tabEvent: function(index){
      this.currentIndex = index;
    }
  }
}
</script>

<style scoped>
.big-home{
  min-width: 1200px;
}
.banner{
  width: 100%;
}
.home-main{
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 48px;
}
.home-main .tit{
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    text-align: left;
}
.home-main .tit a{
  color: #333333;
}
.home-main .tit span{
  cursor: pointer;
}
.home-main .arr-bold{
  font-weight: 600;
}
.home-main .font-blue{
  color: #003B83;
}
.content{
  min-width: 1200px;
}
.content .tab{
  text-align: left;
  padding: 24px 60px;
}
.content .tab li{
  display: inline-block;
  width: 168px;
  height: 60px;
  line-height: 60px;
  background: #AABCD2;
  color: #fff;
  margin-right: 35px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}
.content .tab .active{
  border: 1px solid #003B83;
  background: #fff;
  color: #003B83;
}
.content .circle{
  display: inline-block;
  width: 14px;
  height: 14px;
  background: #003B83;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 20px;
}
.content .text{
  color: #666;
  line-height: 24px;
  text-align: justify;
  margin-bottom: 42px;
}
.content .text-float1,.content .text-float2{
  width: 480px;
}
.content .tab-content{
  background: #fff;
  padding: 40px 60px;
  border: 1px solid #ced7e2;
  min-width: 1200px;
  box-sizing: border-box;
}
.content .enter-ziben{
  line-height: 42px;
}
.content .enter-ziben a{
  color: #003B83;
  font-size: 14px;
  font-weight: 600;
}
.content .tab-content .title{
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  line-height: 32px;
  margin-bottom: 15px;
}
.content .tab-content .img{
  margin-bottom: 20px;
}
 @media screen and (max-width: 1024px){
     .tab-content .mediaImg img{
         width: 860px;
     }
 }
</style>





// WEBPACK FOOTER //
// src/components/bigHome/BigHome.vue